import React from 'react'
import './index.css'

function Titulo() {
    return (
        <div className='titulo'>
            <span>Higher levels = more income.</span>
        </div>
    )
}

export default Titulo